export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9779.0bd85322.jpg";